import React from 'react';
import '../App.css';
import saferlogo from '../assets/safer_tamu_logo.jpg';
import maroonbaselogo from '../assets/maroonbase_logo.jpeg';
import manitlogo from '../assets/manit_logo.png';
import rotaractlogo from '../assets/rotaract_logo.jpeg';
import roobaroologo from '../assets/roobaroo_logo.png';
const Volunteer = () => {
  return (
    
      <>
      <div id="volunteerism">
<div className="education">
    <div className="education-logo">
        <a href="https://www.tamu.edu/emergency/" target="_blank" rel="noreferrer"><img src={saferlogo} alt="SAFER TAMU Logo"></img></a>
    </div>
    <div className='leftalign'>
    <div className="education-text">
        <h3>Emergency Management Texas A&M University</h3>
        <h4>Student Ambassador</h4>
        <h5>Feb 2023 - Dec 2024</h5>
        <ul className="custom-list">
            <li><h6 className="educationh6">🙋🏻‍♀️ Student Ambassadors for Emergency Readiness (SAFER) is a program from the Emergency Management department at TAMU.</h6></li>
            <li><h6 className="educationh6">🙋🏻‍♀️ As part of the SAFER team, I help spread the word to my fellow Aggies about emergency preparedness, resources available on campus for disasters, and other ways to be Standing Ready.</h6></li>
            <li><h6 className="educationh6">🙋🏻‍♀️ I work directly with the Emergency Management team on projects and events that may save lives.</h6></li>
        </ul>
    </div>
    </div>
    </div>

<br />


<div className="education">
    <div className="education-logo">
        <a href="https://launch.tamu.edu/academic-excellence/maroonbase" target="_blank" rel="noreferrer"><img src={maroonbaselogo} alt="maroonbase"></img></a>
    </div>
    <div className='leftalign'>
    <div className="education-text">
        <h3>LAUNCH Maroonbase Texas A&M University</h3>
        <h4>Student Representative</h4>
        <h5>Jul 2023 - Dec 2024</h5>
        <ul className="custom-list">
            <li><h6 className="educationh6">🙋🏻‍♀️ Represent MaroonBase at various campus and community events like Student Organization events, University Office events, On- and Off-Campus Community events.</h6></li>
            <li><h6 className="educationh6">🙋🏻‍♀️ I give presentations to student organizations along with LAUNCH MaroonBase staff.</h6></li>
            
        </ul>
    </div>
    </div>
    </div>
<br />


<div className="education">
    <div className="education-logo">
        <a href="https://www.manit.ac.in/training-placement-and-student-welfare-cell" target="_blank" rel="noreferrer"><img src={manitlogo} alt=""></img></a>
    </div>
    <div className='leftalign'>
    <div className="education-text">
        <h3>Training & Placement Cell MANIT</h3>
        <h4>Computer Science & Engineering - Branch Coordinator</h4>
        <h5>Jul 2018 - Apr 2019</h5>
        <ul className="custom-list">
            <li><h6 className="educationh6">🙋🏻‍♀️ Engaged with industry executives to conduct recruitment drives leading to placements of 210 CS students.</h6></li>
            <li><h6 className="educationh6">🙋🏻‍♀️ Coordinated with various teams to conduct and facilitate online \& offline tests, interviews and group discussions.</h6></li>
            <li><h6 className="educationh6">🙋🏻‍♀️ Assisted students via emails, messages and calls for placement related queries.</h6></li>

        </ul>
    </div>
    </div>
    </div>
<br />

<div className="education">
    <div className="education-logo">
        <a href="https://www.manit.ac.in/content/rotaract-club" target="_blank" rel="noreferrer"><img src={rotaractlogo} alt=""></img></a>
    </div>
    <div className='leftalign'>
    <div className="education-text">
      
        <h3>Rotaract Club MANIT</h3>
        <h4>Media Writer & Coordinator</h4>
        <h5>Jul 2017 - May 2019</h5>
        <ul className="custom-list">
            <li><h6 className="educationh6">🙋🏻‍♀️ Coordinated with local media (newspapers & news channels) to publish club activities news</h6></li>
            <li><h6 className="educationh6">🙋🏻‍♀️ Published annual newsletter Paridrishya for club in 2018 and 2019 along with annual reports</h6></li>
        </ul>
    </div>
    </div>
    </div>
<br />

<div className="education">
    <div className="education-logo">
        <a href="https://www.manit.ac.in/content/rotaract-club" target="_blank" rel="noreferrer"><img src={rotaractlogo} alt=""></img></a>
    </div>
    <div className='leftalign'>
    <div className="education-text">
        <h3>Rotaract Club MANIT</h3>
        <h4>Executive Member</h4>
        <h5>Jul 2016 - May 2019</h5>
        <ul className="custom-list">
            <li><h6 className="educationh6">🙋🏻‍♀️ Delivered Career Counseling sessions to higher secondary students in local government schools.</h6></li>
            <li><h6 className="educationh6">🙋🏻‍♀️ Organized Collection Drives, Distribution Drives and other social services events with team.</h6></li>
            <li><h6 className="educationh6">🙋🏻‍♀️ Managed and hosted orientation, recruitment drive, events in annual fest of college.</h6></li>
        </ul>
    </div>
    </div>
    </div>
<br />

<div className="education">
    <div className="education-logo">
        <a href="https://www.manit.ac.in/content/roobaroo" target="_blank" rel="noreferrer"><img src={roobaroologo} alt=""></img></a>
    </div>
    <div className='leftalign'>
    <div className="education-text">
        <h3>Roobaroo MANIT</h3>
        <h4>Executive Member</h4>
        <h5>Lul 2015 - Apr 2016</h5>
        <ul className="custom-list">
            <li><h6 className="educationh6">🙋🏻‍♀️ Volunteer in Roobaroo, the cultural club of NIT Bhopal, for anchoring and hosted Gig-a-night 1.0.</h6></li>
            <li><h6 className="educationh6">🙋🏻‍♀️ Organized and hosted various events in annual fest of college.</h6></li>
        </ul>
    </div>
    </div>
    </div>
<br />
</div>
      </>

  );
};

export default Volunteer;

